function kindOf (obj, type) {
  return Object.prototype.toString.call(obj) === `[object ${type}]`
}

const Type = {}

const types = [
  'Boolean',
  'Number',
  'Symbol',
  'Null',
  'Undefined',
  'String',
  'Array',
  'RegExp',
  'Date',
  'Function',
  'Object'
]

for (let type of types) {
  Type['is' + type] = obj => { return kindOf(obj, type) }
}

export default Type



// WEBPACK FOOTER //
// ./src/utils/type.js